// File: TimeSheetTask.jsx

import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Input,
  Form,
  FormGroup,
  Label,
  UncontrolledTooltip,
} from "reactstrap";
import { Link } from "react-router-dom";
import Select from "react-select";
import { useFormik } from "formik";
import * as Yup from "yup";
import TableContainer from "../../../../components/Common/TableContainer";
import Breadcrumbs from "../../../../components/Common/Breadcrumb";
import getAccessRights from "components/Common/getAccessRights";
import { useLocation, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import CustomSelect from "components/Common/custom-select";
import { useAuthUserDetails } from "components/Common/getAuthUserDetails";
import { fetchModuleProject, fetchProjectModule, fetchProjectModuleClear, changeTaskStatus, fetchTask, saveTask, generateTaskId } from "store/actions";
import Swal from "sweetalert2";
import Loader from "common/pageLoader";
import useButtonAccess from "components/Common/useButtonAccess";

const TimeSheetTask = () => {
  const [accessRight, setAccessRight] = useState(null);
  const location = useLocation();
  const history = useHistory();
  useEffect(() => {
    const rights = getAccessRights(location.pathname, history);
    setAccessRight(rights?.data);
  }, [location]);
  const { canRead, canCreate, canEdit, canDelete } = useButtonAccess(accessRight);
  const dispatch = useDispatch();
  const [authDetails, setAuthDetails] = useState(null);

  const {
    moduleProject,
    task,
    projectModule,
    taskId,
    loading,
    success,
    error,
  } = useSelector((state) => ({
    moduleProject: state.TimesheetSetupProjectReducer?.moduleProject ?? '',
    task: state.TimesheetSetupTaskReducer?.task ?? [],
    projectModule: state.TimesheetSetupTaskReducer?.projectModule ?? '',
    taskId: state.TimesheetSetupTaskReducer?.taskId ?? '',
    loading: state.TimesheetSetupTaskReducer?.loading,
    error: state.TimesheetSetupTaskReducer?.error,
    success: state.TimesheetSetupTaskReducer?.success,
  }));

  useEffect(() => {
    resetFormData();
    const authUserDetails = useAuthUserDetails();
    setAuthDetails(authUserDetails[0])

    const unitId = authUserDetails[0].unit_id
    const created_by = authUserDetails[0].user_id
    const formData = new FormData();
    formData.append("unit_id", unitId);
    formData.append("create_by", created_by);
    dispatch(fetchModuleProject(formData));
    dispatch(fetchTask(formData));
    const taskIdFormData = new FormData();
    taskIdFormData.append("unit_id", unitId);
    dispatch(generateTaskId(taskIdFormData));
  }, [dispatch]);

  useEffect(() => {
    if (success) {
      const authUserDetails = useAuthUserDetails();
      const unitId = authUserDetails[0].unit_id
      const created_by = authUserDetails[0].user_id
      const formData = new FormData();
      formData.append("unit_id", unitId);
      formData.append("create_by", created_by);
      dispatch(fetchTask(formData));
      const taskIdFormData = new FormData();
      taskIdFormData.append("unit_id", unitId);
      dispatch(generateTaskId(taskIdFormData));
      formik.resetForm();
      setIsEdit(false);
      setEditId(null);
      setEditTaskCode(null);
      resetFormData();
    }
  }, [authDetails, success, dispatch]);

  const [isEdit, setIsEdit] = useState(false);
  const [editId, setEditId] = useState(null);
  const [editTaskCode, setEditTaskCode] = useState(null);
  const [projectData, setProjectData] = useState(null);
  const [moduleData, setModuleData] = useState(null);
  const [assignToData, setAssignToData] = useState(null);
  const [typeData, setTypeData] = useState(null);
  const [natureData, setNatureData] = useState(null);
  const [assignToIds, setAssignToIds] = useState([]);
  const selectedProjectIdRef = React.useRef(null);

  useEffect(() => {
    if (Array.isArray(moduleProject) && moduleProject.length > 0 && selectedProjectIdRef.current) {
      const selectedProject = moduleProject.find(p => p.value === selectedProjectIdRef.current);
      if (selectedProject) {
        formik.setFieldValue("projecthours", selectedProject.project_total_hours || "");
        formik.setFieldValue("remaining_hours", selectedProject.remaining_hours || "");
      }
    }
  }, [moduleProject]);

  useEffect(() => {
    const accessRight = getAccessRights(location.pathname, history);
  }, [location]);

  useEffect(() => {
    if (projectModule?.assignto && isEdit && assignToIds.length > 0) {
      const selectedValues = projectModule?.assignto.filter(option => assignToIds.includes(String(option.value)));
      formik.setFieldValue("assignTo", selectedValues);
      setAssignToData(selectedValues);
    }
  }, [projectModule?.assignto && isEdit && assignToIds.length > 0]);

  const formik = useFormik({
    initialValues: {
      project: "",
      module: "",
      task: "",
      description: "",
      type: "",
      nature: "",
      assignTo: [],
      hours: "",
      projecthours: "",
      remaining_hours: "",
    },
    validationSchema: Yup.object({
      project: Yup.object().nullable().required("Project is required"),
      module: Yup.object().nullable().required("Module is required"),
      task: Yup.string().required("Task is required"),
      // .max(50, "Task must be at most 50 characters"),
      description: Yup.string().required("Description is required"),
      // .max(200, "Description must be at most 200 characters"),
      type: Yup.object().nullable().required("Type is required"),
      nature: Yup.object().nullable().required("Nature is required"),
      assignTo: Yup.array().min(1, "Assign To is required"),
      //hours: Yup.string().required("Task Hours is required"),
      //hours: Yup.string().matches(/^([01]\d|2[0-3]):([0-5]\d)$/, 'Invalid time format (HH:MM 24-hour)').required('Task Hours is required'),
      hours: Yup.string().matches(/^\d+:[0-5]\d$/, 'Invalid time format. Use HH:MM, with minutes between 00-59').required('Task Hours is required'),
    }),
    onSubmit: (values, { resetForm }) => {

      const assign_ids = values.assignTo.map(option => option.value);
      const formData = new FormData();
      formData.append("task_id", editId ? editId : 0);
      formData.append("task_code", editId ? editTaskCode : taskId);
      formData.append("task", values.task);
      formData.append("module_id", values.module.value);
      formData.append("project_id", values.project.value);
      formData.append("description", values.description);
      formData.append("task_hours", values.hours);
      formData.append("assign_id", assign_ids);
      formData.append("task_type", values.type.value);
      formData.append("task_nature", values.nature.value);
      formData.append("rem_hours", values.remaining_hours);
      formData.append("create_by", authDetails?.user_id);
      formData.append("unit_id", authDetails?.unit_id);
      dispatch(saveTask(formData));
      // resetFormData(); 
    },
  });

  const handleEdit = (row) => {
    setIsEdit(true);
    setEditId(row.task_id);
    setEditTaskCode(row.task_code);
    fetchProjectModuleData(row.project_id);

    const selectedIds = row.staff_assign_id ? row.staff_assign_id.split(",") : [];
    const trimmedSelectedIds = selectedIds.map(str => str.trim());
    const selectedValues = projectModule?.assignto ? projectModule?.assignto.filter(option => trimmedSelectedIds.includes(String(option.value))) : [];
    const selectedProject = moduleProject.find(p => p.value === row.project_id);

    formik.setValues({
      project: { value: row.project_id, label: row.project_name },
      module: { value: row.module_id, label: row.module_name },
      task: row.task,
      description: row.description,
      type: { value: row.task_type_id, label: row.task_type },
      nature: { value: row.task_nature_id, label: row.task_nature },
      hours: row.task_hours,
      assignTo: selectedValues,
    });
    setProjectData({ value: row.project_id, label: row.project_name });
    setModuleData({ value: row.module_id, label: row.module_name });
    setTypeData({ value: row.task_type_id, label: row.task_type });
    setNatureData({ value: row.task_nature_id, label: row.task_nature });
    setAssignToData(selectedValues);

    formik.setFieldValue("project", { value: row.project_id, label: row.project_name });
    formik.setFieldValue("module", { value: row.module_id, label: row.module_name });
    formik.setFieldValue("type", { value: row.task_type_id, label: row.task_type });
    formik.setFieldValue("nature", { value: row.task_nature_id, label: row.task_nature });
    formik.setFieldValue("assignTo", selectedValues);

    formik.setFieldValue("projecthours", selectedProject?.project_total_hours || "");
    formik.setFieldValue("remaining_hours", selectedProject?.remaining_hours || "");
    selectedProjectIdRef.current = row.project_id;
    setAssignToIds(trimmedSelectedIds);

  };

  const handleToggleStatus = (id, isActive) => {
    Swal.fire({
      title: 'Are you sure?',
      text: `You are about to ${isActive ? 'deactivate' : 'activate'} this task.`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Confirm',
      cancelButtonText: 'Cancel',
      reverseButtons: false,
      dangerMode: true,
    }).then((result) => {
      if (result.isConfirmed) {
        const formData = new FormData();
        formData.append("task_id", id);
        formData.append("create_by", authDetails?.user_id);
        formData.append("unit_id", authDetails?.unit_id);
        dispatch(changeTaskStatus(formData));
      }
    });
  };

  const CustomSelect = ({
    closeMenuOnScroll = true,
    menuPortalTarget = document.body,
    menuPosition = "fixed",
    menuShouldScrollIntoView = false,
    ...props
  }) => {
    return (
      <Select
        {...props}
        closeMenuOnScroll={closeMenuOnScroll}
        menuPortalTarget={menuPortalTarget}
        menuPosition={menuPosition}
        menuShouldScrollIntoView={menuShouldScrollIntoView}
        styles={{
          menuPortal: (base) => ({
            ...base,
            zIndex: 9999,
          }),
          menu: (base) => ({
            ...base,
            zIndex: 9999,
            borderRadius: "8px",
          }),
          control: (base, state) => ({
            ...base,
            minHeight: 42,
            maxHeight: 42,
            borderColor: state.isFocused ? "#2684FF" : "#ced4da",
            boxShadow: state.isFocused ? "0 0 0 1px #2684FF" : "none",
            "&:hover": {
              borderColor: "#2684FF",
            },
            fontSize: "14px",
            borderRadius: "8px",
          }),
        }}
      />
    );
  };

  const fetchProjectModuleData = (id) => {
    const formData = new FormData();
    formData.append("project_id", id);
    formData.append("unit_id", authDetails?.unit_id);
    formData.append("created_by", authDetails?.user_id);
    dispatch(fetchProjectModule(formData));
  };

  const resetFormData = () => {
    //formik.resetForm(); 
    setIsEdit(false);
    setEditId(null);
    setEditTaskCode(null);
    setProjectData(null);
    setModuleData(null);
    setAssignToData(null);
    setTypeData(null);
    setNatureData(null);
    formik.values.client = '';
    formik.values.service = '';
    dispatch(fetchProjectModuleClear());
    formik.setFieldValue("module", '');
    formik.resetForm({
      values: {
        project: "",
        module: "",
        task: "",
        description: "",
        type: "",
        nature: "",
        assignTo: [],
        hours: "",
        projecthours: "",
        remaining_hours: "",
      },
    });
  };

  const columns = [
    { Header: "S.No", Cell: ({ row }) => task.length - row.index, className: "serial-no text-center", applyHeaderClass: true },
    {
      Header: "Actions",
      headerClassName: "text-center",
      className: "text-center",
      Cell: (cellProps) => {
        const { b_active, task_id } = cellProps.row.original;
        const isActive = b_active === 1;

        return (
          <div className="text-center">

            {/* STATUS TOGGLE */}
            {canDelete && (
              <>
                <span
                  id={`status-${task_id}`}
                  className="me-2"
                  style={{ color: isActive ? "green" : "red", cursor: "pointer" }}
                  onClick={() => handleToggleStatus(task_id, isActive)}
                >
                  <i
                    className={`mdi ${isActive ? "mdi-check-circle" : "mdi-close-circle"
                      } font-size-18`}
                  />
                </span>

                <UncontrolledTooltip
                  placement="top"
                  target={`status-${task_id}`}
                  delay={{ show: 300, hide: 100 }}
                >
                  {isActive ? "Mark Inactive" : "Mark Active"}
                </UncontrolledTooltip>
              </>
            )}

            {/* EDIT */}
            {canEdit && (
              <>
                <span
                  id={`edit-${task_id}`}
                  className="text-success ms-2"
                  style={{ cursor: "pointer" }}
                  onClick={() => handleEdit(cellProps.row.original)}
                >
                  <i className="bx bxs-edit font-size-18" />
                </span>

                <UncontrolledTooltip
                  placement="top"
                  target={`edit-${task_id}`}
                  delay={{ show: 300, hide: 100 }}
                >
                  Edit
                </UncontrolledTooltip>
              </>
            )}

          </div>
        );
      },
    },
    { Header: "Client", accessor: "client_name" },
    { Header: "Project", accessor: "project_name" },
    { Header: "Module", accessor: "module_name" },
    { Header: "Task Code", accessor: "task_code" },
    { Header: "Task", accessor: "task" },
    { Header: "Task Type", accessor: "task_type" },
    { Header: "Task Nature", accessor: "task_nature" },
    { Header: "Description", accessor: "description" },
    { Header: "Assign To", accessor: "staff_assigns" },
    { Header: "Hours", accessor: "task_hours" },
    { Header: "Created By", accessor: "create_by" },
    { Header: "Created On", accessor: "create_on" },
  ];

  return (
    <div className="page-content">
      <Loader loading={loading} />
      <Container fluid>
        <Breadcrumbs title="Timesheet" breadcrumbItem="Task" />
        <Card>
          <CardBody>
            <Form onSubmit={formik.handleSubmit}>
              <Row className="mb-2">
                <Col md={4}>
                  <FormGroup>
                    <Label>Task Code</Label>
                    <Input type="text" name="task_id" placeholder="0" value={editId ? editTaskCode : taskId} disabled />
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup>
                    <Label>Project <span className="text-danger">*</span></Label>
                    <CustomSelect
                      id="project"
                      name="project"
                      isMulti={false}
                      options={moduleProject}
                      closeMenuOnScroll={false}
                      menuPosition="absolute"
                      menuPortalTarget={null}
                      value={projectData}
                      onChange={(selectedOption) => {
                        formik.setFieldValue("project", selectedOption);
                        setProjectData(selectedOption);
                        formik.setFieldValue("projecthours", selectedOption?.project_total_hours || "");
                        formik.setFieldValue("remaining_hours", selectedOption?.remaining_hours || "");
                        selectedProjectIdRef.current = selectedOption?.value;
                        formik.setFieldValue("module", "");
                        formik.setFieldValue("assignTo", []);
                        formik.setFieldValue("type", "");
                        formik.setFieldValue("nature", "");
                        formik.setFieldValue("task", "");
                        formik.setFieldValue("description", "");
                        formik.setFieldValue("hours", "");
                        setModuleData(null);
                        setAssignToData(null);
                        setTypeData(null);
                        setNatureData(null);
                        fetchProjectModuleData(selectedOption?.value);
                        const formData = new FormData();
                        formData.append("unit_id", authDetails?.unit_id);
                        formData.append("create_by", authDetails?.user_id);
                        dispatch(fetchModuleProject(formData));
                      }}
                      onBlur={() => formik.setFieldTouched("project", true)}
                    />
                    {formik.touched.project && formik.errors.project && (
                      <div className="text-danger">{formik.errors.project}</div>
                    )}
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup>
                    <Label>Module <span className="text-danger">*</span></Label>
                    <CustomSelect
                      id="module"
                      name="module"
                      isMulti={false}
                      options={projectModule?.module}
                      closeMenuOnScroll={false}
                      menuPosition="absolute"
                      menuPortalTarget={null}
                      value={moduleData}
                      onChange={(selectedOption) => { formik.setFieldValue("module", selectedOption); setModuleData(selectedOption); }}
                      onBlur={() => formik.setFieldTouched("module", true)}
                    />
                    {formik.touched.module && formik.errors.module && (
                      <div className="text-danger">{formik.errors.module}</div>
                    )}
                  </FormGroup>
                </Col>
              </Row>
              <Row className="mb-2">
                <Col md={4}>
                  <FormGroup>
                    <Label>Task <span className="text-danger">*</span></Label>
                    <Input type="text" name="task" value={formik.values.task} onChange={formik.handleChange} onBlur={formik.handleBlur} className={formik.errors.task && formik.touched.task ? "is-invalid" : ""} />
                    {formik.touched.task && formik.errors.task && (
                      <div className="text-danger">{formik.errors.task}</div>
                    )}
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup>
                    <Label>Description <span className="text-danger">*</span></Label>
                    <Input type="textarea" name="description" value={formik.values.description} onChange={formik.handleChange} onBlur={formik.handleBlur} style={{ maxHeight: "33.1px", minHeight: "33.1px" }} />
                    {formik.touched.description && formik.errors.description && (
                      <div className="text-danger">{formik.errors.description}</div>
                    )}
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup>
                    <Label>Assign To <span className="text-danger">*</span></Label>
                    <CustomSelect
                      id="assignTo"
                      name="assignTo"
                      isMulti={true}
                      options={projectModule?.assignto}
                      closeMenuOnScroll={false}
                      menuPosition="absolute"
                      menuPortalTarget={null}
                      value={assignToData}
                      onChange={(selectedOption) => { formik.setFieldValue("assignTo", selectedOption); setAssignToData(selectedOption); }}
                      onBlur={() => formik.setFieldTouched("assignTo", true)}
                    />
                    {formik.errors.assignTo && formik.touched.assignTo && (
                      <div className="text-danger">{formik.errors.assignTo}</div>
                    )}
                  </FormGroup>
                </Col>
              </Row>
              <Row className="mb-2 ">
                <Col md={4}>
                  <FormGroup>
                    <Label>Task Hours <span className="text-danger">*</span></Label>
                    <Input type="text" name="hours" placeholder="HH:MM" value={formik.values.hours} onChange={formik.handleChange} onBlur={formik.handleBlur} className={formik.errors.hours && formik.touched.hours ? "is-invalid" : ""} />
                    {formik.errors.hours && formik.touched.hours && (
                      <div className="text-danger">{formik.errors.hours}</div>
                    )}
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup>
                    <Label>Rem.Task Hours</Label>
                    <Input type="text" name="remaining_hours" placeholder="HH:MM" value={formik.values.remaining_hours} disabled />
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup>
                    <Label>Type <span className="text-danger">*</span></Label>
                    <CustomSelect
                      id="type"
                      name="type"
                      isMulti={false}
                      options={projectModule?.tasktype}
                      closeMenuOnScroll={false}
                      menuPosition="absolute"
                      menuPortalTarget={null}
                      value={typeData}
                      onChange={(selectedOption) => { formik.setFieldValue("type", selectedOption); setTypeData(selectedOption); }}
                      onBlur={() => formik.setFieldTouched("type", true)}
                    />
                    {formik.errors.type && formik.touched.type && (
                      <div className="text-danger">{formik.errors.type}</div>
                    )}
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup>
                    <Label>Nature <span className="text-danger">*</span></Label>
                    <CustomSelect
                      id="nature"
                      name="nature"
                      isMulti={false}
                      options={projectModule?.tasknature}
                      closeMenuOnScroll={false}
                      menuPosition="absolute"
                      menuPortalTarget={null}
                      value={natureData}
                      onChange={(selectedOption) => { formik.setFieldValue("nature", selectedOption); setNatureData(selectedOption); }}
                      onBlur={() => formik.setFieldTouched("nature", true)}
                    />
                    {formik.errors.nature && formik.touched.nature && (
                      <div className="text-danger">{formik.errors.nature}</div>
                    )}
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup>
                    <Label>Project Hours</Label>
                    <Input type="text" name="projecthours" placeholder="HH:MM" value={formik.values.projecthours} onChange={formik.handleChange} disabled />
                  </FormGroup>
                </Col>
                <Col className="d-flex mob-center align-items-center justify-content-end mt-2">
                  {canCreate && (
                    <Button type="submit" color="primary1" className="btn button-save me-2"> <i className="fas fa-save me-1" /> {editId ? "Update" : "Save"}</Button>
                  )}
                  <Button type="button" className="btn button-cancel me-2" onClick={() => { resetFormData(); }}>
                    <i className="fas fa-sync me-1" /> Cancel
                  </Button>
                </Col>
              </Row>
            </Form>
          </CardBody>
        </Card>

        <Card>
          <CardBody>
            <TableContainer columns={columns} data={task} isGlobalFilter={true} customPageSize={10} />
          </CardBody>
        </Card>
      </Container>
    </div>
  );
};

export default TimeSheetTask;
